<template>
  <div>
    <v-dialog
      v-model="dialog"
      persistent
      scrollable
      max-width="600"
    >
      <v-card>
        <v-card-title class="headline primary white--text">
          Choose Your Location
        </v-card-title>

        <v-card-text class="pt-4">
          s
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="darken-1" text @click="closeDialog">Close</v-btn>
          <v-btn
            color="primary"
            text
            :loading="loading"
            @click="setLocation"
          >
            Set Location & Check Availability
            <v-icon small right>mdi-delete-circle-outline</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import HasDialog from '@/mixins/HasDialog'

export default {
  name: 'ChooseLocationDialog',

  mixins: [HasDialog],

  data () {
    return {
      loading: false
    }
  },

  methods: {
    setLocation () {
      //
    }
  }
}
</script>
